module.exports = __webpack_public_path__ + "static/media/mobile.4513eb76.svg";